import * as React from 'react';
import { OpenQuoteTableHeader } from './OpenQuoteTableHeader';
import Helper from 'src/support/Helper';
import { useState, useEffect } from "react";
import { ViewOpenQuote } from './ViewOpenQuote';
import { useQuoteStore } from 'src/hooks/quote';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import RefreshStockButton from '../ProductListing/RefreshStockButton';
import { Pagination } from 'src/reusable/global';
import NoResultContent from '../HomePageContent/NoResultContent';
import ProductInventoryRepository from 'src/repository/ProductInventoryRepository';
import useCheckAuthPermissions from 'src/hooks/component/useCheckAuthPermissions';
import ReusableDiv from 'src/support/ReusableDiv';
import stickyTableHeader from 'src/helper/stickyTableHeader';
import liveAuth from "src/helper/liveAuth";

export function OpenQuoteListing() {
    const [{ openQuoteList, isSuccessAction }, { fetch_open_quote_list }, { set_is_success_action }] = useQuoteStore();
    const [__check] = useAxiosIndicatorCheck();
    const [_check_p] = useCheckAuthPermissions();
    const [listObj, setListObj] = useState({
        pageCount: 0,
        page: 1,
        limit: 20,
        sortBy: '',
        sortOrder: '',
        ascDesField: {}
    });

    const [firstServerCall, setFirstServerCall] = useState(true);
    const [monitorFunctionCall, setMonitorFunctionCall] = useState(false);

    const setPageLimit = async (event) => {
        setListObj({ ...listObj, page: 1, limit: event.target.value });
    };

    useEffect(() => {
        window.scrollTo({ top: 0 });
        if (firstServerCall === false && liveAuth.check() && !monitorFunctionCall) {
            Helper.monitorJSDx()
            setMonitorFunctionCall(true)
        }
    }, [openQuoteList])

    useEffect(() => {
        setListObj({ ...listObj, pageCount: Math.ceil(openQuoteList?.count / listObj.limit) })

    }, [openQuoteList]);

    useEffect(() => {
        async function fetchHere() {
            setFirstServerCall(false)
            await fetch_open_quote_list({
                "top": listObj.limit,
                "skip": Helper.getSkipCount(listObj.page, listObj.limit),
                "sortBy": listObj.sortBy,
                "sortOrder": listObj.sortOrder
            })
        }

        fetchHere()
    }, [listObj.page, listObj.limit, listObj.sortBy, listObj.sortOrder]);

    useEffect(() => {
        async function fetchHere() {
            await fetch_open_quote_list({
                "top": listObj.limit,
                "skip": Helper.getSkipCount(listObj.page, listObj.limit),
                "sortBy": listObj.sortBy,
                "sortOrder": listObj.sortOrder
            })
        }

        if (isSuccessAction) {
            fetchHere();
            set_is_success_action(false)
        }
    }, [isSuccessAction]);

    const refreshStock = async () => {
        await new ProductInventoryRepository().refreshAllProductInventoryRunTimeAvailable()
    }

    const handlePageClick = async (data) => {
        let page = Helper.handlePageClick(data, pageCount);
        setListObj({ ...listObj, page: page })
        Helper.scrollTop();
    };

    const toggleOrderBy = async (columnName) => {
        if (listObj.ascDesField.hasOwnProperty(columnName)) {
            listObj.ascDesField[columnName] = listObj.ascDesField[columnName] === 'ASC' ? 'DESC' : 'ASC'
            setListObj({ ...listObj, ascDesField: listObj.ascDesField})
           
        } else {
            listObj.ascDesField[columnName] = 'ASC'
            setListObj({ ...listObj, ascDesField: listObj.ascDesField})

        }
        setListObj({ ...listObj, sortBy: columnName,sortOrder:listObj.ascDesField[columnName] })

    };

    const getOrderByClass = (columnName) => {
        if (listObj.sortBy === columnName && listObj.ascDesField.hasOwnProperty(columnName)) {
            return 'sorting sorting_' + listObj.ascDesField[columnName].toLowerCase()
        }
        return 'sorting'
    };

    useEffect(() => {
        let isDisplayFixedHeader;
        let refreshStockButton;
        let callback;

        if ((openQuoteList !== undefined && Object.keys(openQuoteList) !== undefined
            && openQuoteList.count > 0)) {
            const sort = toggleOrderBy;
            const tableElement = document?.getElementById("openquotelisting-table");
            // headerHeght contains height where we need to display static header
            // local
            // const headerHeight =  document?.getElementsByTagName("header") ? document?.getElementsByTagName("header")[0]?.clientHeight :65;
            //sbx
            let headerHeight = document?.getElementsByClassName("navbar navbar-default white") ? document?.getElementsByClassName("navbar-default")[0]?.clientHeight + 1 : 156;

            // Admin Toolbar header height adjustment
            const adminToolBarHeight = document?.getElementsByClassName("wpToolbarActionBar wpToolbarCommon")?.length > 0 ? document?.getElementsByClassName("wpToolbarActionBar wpToolbarCommon")[0]?.clientHeight : 0;

            if (adminToolBarHeight > 0) {
                headerHeight = headerHeight + adminToolBarHeight;
            }
            // is used to track only one header will display at a moment
            // extra function attach 
            document.addEventListener("scroll", (ScrollEvent) => {
                // current table position from top
                const tablePosition = tableElement ? tableElement.getBoundingClientRect().y : false;
                const paginationPosition = document?.querySelectorAll("div.pagination-row") ? document?.querySelectorAll("div.pagination-row")[0]?.getBoundingClientRect()?.y : false;

                if (tablePosition && headerHeight > tablePosition && isNaN(paginationPosition) === false && (Number(headerHeight) + 40 <= Number(paginationPosition)) && !isDisplayFixedHeader) {
                    //function used to display header clone after actual header height is less than headerHeight from top
                    // function(id, headerHeight,  tableContainerId, firstColumnsFixed, sort)
                    if (!document.getElementById("table_copy")) {
                        callback = stickyTableHeader("openquotelisting-table", headerHeight, "sticky-table-wrapper", 1, sort)
                        isDisplayFixedHeader = true;
                        refreshStockButton = document.getElementsByClassName("refresh-link")
                        refreshStockButton[refreshStockButton.length - 1].addEventListener("click", refreshStock);
                    }
                } else {
                    if ((headerHeight < tablePosition || (Number(paginationPosition) <= Number(headerHeight) + 40)) && isDisplayFixedHeader && callback) {
                        // switch variable to false for track that clone header hide
                        isDisplayFixedHeader = false;
                        // check element exist before remove event listeners
                        if (refreshStockButton && refreshStockButton[refreshStockButton.length - 1] && refreshStock) {
                            refreshStockButton[refreshStockButton.length - 1]?.removeEventListener("click", refreshStock);
                        }
                        // function used to remove the clone header
                        if (Object.prototype.toString.call(callback) == '[object Function]') {
                            callback();
                        }
                    }
                }
            })
            return () => {
                if (callback) {
                    // switch variable to false for track that clone header hide
                    isDisplayFixedHeader = false;
                    // check element exist before remove event listeners
                    if (refreshStockButton && refreshStockButton[refreshStockButton.length - 1] && refreshStock) {
                        refreshStockButton[refreshStockButton.length - 1]?.removeEventListener("click", refreshStock);
                    }
                    // function used to remove the clone header
                    callback();
                    window.scrollTo(0, 0)
                }
            }
        }
    }, [openQuoteList, __check(['QUOTE_API_CALL']).status])
    return (
        <>
            {_check_p('OPEN_QT_VIEW').status &&
                <div id="main" className="">
                    {ReusableDiv.QuoteHeader()}
                    <div id="pcnquote-page" className="pcn-page container">
                        <div className='sub-title mt-0'>My Open Quotes</div>
                        <p className='mb-4'>This is a collection of line items selected online, that has not been sent for quoting to the sales representative.</p>
                        <div className="content-box container api-request-content p-0 quote-tabs">
                            <OpenQuoteTableHeader />
                            <>
                                <div className='quote-tabs-content'>
                                    <div id="sticky-table-wrapper" className="table-responsive position-relative sticky-table-wrapper mx-3 pt-3 border-0">
                                        <div>
                                            {__check(['QUOTE_API_CALL'], { overlay: true }).render}
                                        </div>
                                        {__check(['QUOTE_API_CALL']).status || (openQuoteList !== undefined
                                            && Object.keys(openQuoteList) !== undefined
                                            && openQuoteList.count > 0) ?
                                            <>
                                                <table id="openquotelisting-table" className="bs5 table table-bordered table-striped quotes-table">
                                                    <thead>
                                                        <tr>
                                                            <th className="edit-quote-head" />
                                                            <th><span>Part Information</span>
                                                                <span aria-label='PartNumber' className={'sort-container ' + getOrderByClass('PartNumber')}
                                                                    onClick={async () => { await toggleOrderBy('PartNumber') }}></span>
                                                            </th>
                                                            <th><span>Quantity</span>
                                                                <span aria-label='Quantity1' className={'sort-container ' + getOrderByClass('Quantity1')}
                                                                    onClick={async () => { await toggleOrderBy('Quantity1') }}></span>
                                                            </th>
                                                            <th>Target Unit Price</th>

                                                            <th>Price</th>
                                                            <th> Availability
                                                                <RefreshStockButton fetchInventoryFromServer={refreshStock} />
                                                            </th>
                                                            <th> quote information </th>
                                                        </tr>
                                                    </thead>
                                                    {_check_p('OPEN_QT_VIEW').status &&
                                                        (openQuoteList !== undefined && Object.keys(openQuoteList) !== undefined
                                                            && openQuoteList.count > 0) &&
                                                        <tbody>
                                                            {openQuoteList !== undefined && Object.keys(openQuoteList).length > 0 && Object.keys(openQuoteList.records).length > 0 && Object.keys(openQuoteList.records) !== undefined
                                                                && Object.keys(openQuoteList.records).map((v, i) => (
                                                                    <ViewOpenQuote
                                                                        key={i}
                                                                        currentQuote={openQuoteList.records[v]}
                                                                        apiParams={{
                                                                            "top": listObj.limit,
                                                                            "skip": Helper.getSkipCount(listObj.page, listObj.limit),
                                                                            "sortBy": listObj.sortBy,
                                                                            "sortOrder": listObj.sortOrder
                                                                        }}
                                                                    />
                                                                ))}
                                                        </tbody>
                                                    }
                                                </table>

                                                <Pagination pageCount={listObj.pageCount} handlePageClick={handlePageClick} setPageLimit={setPageLimit} page={listObj.page - 1} limit={listObj.limit} />
                                            </>
                                            : 0 < 1 &&
                                            <div className="mt-3">
                                                <NoResultContent message={"There are no open quotes for this account"} isDisplay={false} />
                                            </div>
                                        }
                                    </div>
                                </div>
                            </>
                        </div>
                    </div>
                </div>
            }
        </>
    );

}
